import axios from '@/apis/axios';
import { transformObjectValuesToUpperCase } from '@/transformer/transform';

class Fee
{
    static async all()
    {
        const response = await axios.get('api/admin/setup/fees');

        return response.data.data;
    }

    static async getNatureAndServiceOptions()
    {
        const response = await axios.get('api/admin/setup/fees/natures-and-services');
        return response.data.data;
    }

    static async create(data)
    {
        const response = await axios.post('api/admin/setup/fees', transformObjectValuesToUpperCase(data));

        return response.data.data;
    }

    static async update(id, data)
    {
        const response = await axios.put(`api/admin/setup/fees/${id}`, transformObjectValuesToUpperCase(data));

        return response;
    }
}
export default Fee;